import accounting from 'accounting'

export function currency(val){
  return accounting.formatMoney(val,"$", 2, ",", ".", "%s %v")
}

export function trim(val){
  if (val) {
    return val.trim().replace(/(\r\n|\n|\r)/gm,"")
  }
  return val;
}



// WEBPACK FOOTER //
// ./src/filters/index.js